.root {
  display: inline-flex;
  flex-shrink: 0;
  color: currentColor;
}

.xs {
  width: 0.75rem;
  height: 0.75rem;
}

.sm {
  width: 1rem;
  height: 1rem;
}

.md {
  width: 1.5rem;
  height: 1.5rem;
}

.lg {
  width: 2.25rem;
  height: 2.25rem;
}

.svg {
  width: 100%;
  height: 100%;
  animation: spin 0.8s linear infinite;
}

.track {
  stroke: currentColor;
  opacity: 0.2;
}

.arc {
  stroke: currentColor;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  /* Keep a slow rotation so "busy" is still perceivable, per WCAG 2.3.3 guidance. */
  .svg {
    animation-duration: 2.4s !important;
    animation-iteration-count: infinite !important;
  }
}
